import DisconnectIcon from '@/assets/icons/disconnect.svg?react';
import { IconButton } from '@/lib';
import { Audience } from '@/models/audiences';
import { DistributionChannel } from '@/models/distributionChannels';
import { FC, useReducer } from 'react';
import { DisconnectDestinationModal } from './modals/DisconnectDestinationModal';

type AudieneDestinationDisconnectButtonProps = {
  audience: Audience;
  destination: DistributionChannel;
};

export const AudieneDestinationDisconnectButton: FC<AudieneDestinationDisconnectButtonProps> = ({ audience, destination }) => {
  const [isModalOpen, toggleModal] = useReducer((state) => !state, false);

  return (
    <>
      <IconButton
        intent='link-grey'
        className='!p-1.5 text-tertiary-600'
        leadingIcon={<DisconnectIcon className='text-quaternary-400' />}
        onClick={toggleModal}
      />
      {isModalOpen && <DisconnectDestinationModal audience={audience} destination={destination} closeModal={toggleModal} />}
    </>
  );
};
